declare const __APP_VERSION__: string

export const FRONTEND_VERSION = __APP_VERSION__
